import React from 'react'
import Card from '../shared/card/card.jsx'
import root from '../shared/utils'

const ZoneCard = ({data, zoneNum}) => {
  let mediaServer = root + '/common/latest/images/consumer'
  let backImage = mediaServer + '/map-zones/zone-' + zoneNum + '.png'
  let header = 'Your Yard Care Zone'

  let leafIcon = mediaServer + '/leaf-gardening-tip.png'

  return (
    <Card
      headerTitle={header}>
      <img role='presentation' className='img-responsive center-block' src={backImage} />
      <h4 className='brand-primary-color'>{data.header}</h4>
      <p className='text-left charcoal-gray-color' dangerouslySetInnerHTML={{ __html: data.headerContent }} />
      <hr style={{'borderTopColor': '#818181'}} />
      <h4 className='brand-primary-color'>{data.subHeader}</h4>
      <p className='text-center charcoal-gray-color'>{data.subHeaderContent}</p>
      <hr style={{'borderTopColor': '#818181'}} />
      <h4 className='brand-primary-color'>{data.gardeningTipHeader}</h4>
      <div className='row'>
        <div className='col-xs-3'>
          <img src={leafIcon} alt='leaf' />
        </div>
        <span className='col-xs-9 text-left charcoal-gray-color'>{data.gardeningTipContent}</span>
      </div>
    </Card>
  )
}

ZoneCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  zoneNum: React.PropTypes.number.isRequired
}

export default ZoneCard



// WEBPACK FOOTER //
// ./src/components/dashboard/zone-card.jsx